import { getEnvVariableValue } from '@experiences/util';

const useIsOnPrem = () => getEnvVariableValue('isOnPrem') || getEnvVariableValue('name') === 'k8s';

export default useIsOnPrem;
